module.exports = __webpack_public_path__ + "img/宜宾市第一人民医院.5b2e1673.png";